import { lazy, Suspense } from 'react';
import Navigation from '@/components/Navigation';
import HeroSection from '@/components/HeroSection';
import ApartmentGallery from '@/components/ApartmentGallery';
import Footer from '@/components/Footer';

const ExperiencesSection = lazy(() => import('@/components/ExperiencesSection'));
const AboutSection = lazy(() => import('@/components/AboutSection'));
const TestimonialCarousel = lazy(() => import('@/components/TestimonialCarousel'));
const ContactForm = lazy(() => import('@/components/ContactForm'));
import CookieConsent from '@/components/CookieConsent';
import SEO from '@/components/SEO';

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Roma Dream Escape — Premium Holiday Rentals in Rome"
        description="Luxury apartments in Rome's iconic neighborhoods: Monti, Navona, Trastevere & Termini. Book your premium Roman holiday with curated local experiences."
        path="/"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "LodgingBusiness",
          name: "Roma Dream Escape",
          url: "https://romadreamescape.com",
          areaServed: "Rome, Italy",
          priceRange: "$$$",
        }}
      />
      <Navigation />
      <main>
        <HeroSection />
        <ApartmentGallery />
        <Suspense fallback={null}>
          <ExperiencesSection />
          <AboutSection />
          <TestimonialCarousel />
          <ContactForm />
        </Suspense>
      </main>
      <Footer />
      <CookieConsent />
    </div>
  );
};

export default Index;
